import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=7c54f302&scoped=true"
import script from "./ToolsPanel.vue?vue&type=script&lang=js"
export * from "./ToolsPanel.vue?vue&type=script&lang=js"
import style0 from "./ToolsPanel.vue?vue&type=style&index=0&id=7c54f302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54f302",
  null
  
)

export default component.exports